import { ISuggestedProduct, ISuggestedSearch, ISuggestedSearchTerm } from './predictive-search.model';

export function isSuggestedSearchTerm(searchTerm: ISuggestedSearch): searchTerm is ISuggestedSearchTerm {
  return (searchTerm as ISuggestedSearchTerm).__typename === 'SuggestedSearchTerm';
}

export function isSuggestedProduct(searchTerm: ISuggestedSearch): searchTerm is ISuggestedProduct {
  return (searchTerm as ISuggestedProduct).__typename === 'SuggestedProduct';
}
